import { createFileRoute } from "@tanstack/react-router";
import { format, parseISO } from "date-fns";
import { Trophy, ExternalLink } from "lucide-react";
import { AppHeader } from "@/components/app/AppHeader";
import { useWinners } from "@/hooks/use-scriptwriter-tasks";

export const Route = createFileRoute("/_app/winners")({
  component: WinnersPage,
});

function WinnersPage() {
  const { data: winners = [], isLoading } = useWinners();

  return (
    <>
      <AppHeader subtitle="Scripts marked as winners by admins" />
      <div className="px-[22px] pb-6">
        <div className="rounded-lg border border-border bg-card p-5 shadow-sm">
          <div className="mb-3 flex items-center gap-2">
            <Trophy className="h-4 w-4 text-amber-500" />
            <h2 className="text-[16px] font-bold">Winning Scripts</h2>
          </div>
          {isLoading && <p className="text-[12px] text-muted-foreground">Loading…</p>}
          {!isLoading && winners.length === 0 && (
            <p className="text-[12px] text-muted-foreground">No winners yet.</p>
          )}
          <div className="grid gap-3">
            {winners.map((w) => (
              <div key={w.id} className="rounded-md border border-border p-3">
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0">
                    <div className="text-[13px] font-semibold">{w.script_title}</div>
                    <div className="text-[11px] text-muted-foreground">
                      {w.product_name} · {w.brand} · {format(parseISO(w.submission_date), "EEE, dd MMM yyyy")}
                    </div>
                  </div>
                  <a
                    href={w.drive_link}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex shrink-0 items-center gap-1 text-[11px] text-blue-600 hover:underline"
                  >
                    <ExternalLink className="h-3 w-3" /> Open
                  </a>
                </div>
                {w.notes && <p className="mt-2 text-[11px] text-muted-foreground">{w.notes}</p>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
